/* tslint:disable */
/* eslint-disable */
/**
 * Geckosoft.Backend.Api | geckosoft-v0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const AnalysisStatus = {
    UserEdit: 'userEdit',
    UserRunningAnalysis: 'userRunningAnalysis',
    UserReview: 'userReview',
    UserRunningEvaluation: 'userRunningEvaluation',
    AdminEdit: 'adminEdit',
    AdminRunningAnalysis: 'adminRunningAnalysis',
    AdminRunningEvaluation: 'adminRunningEvaluation',
    AdminReview: 'adminReview',
    Final: 'final'
} as const;
export type AnalysisStatus = typeof AnalysisStatus[keyof typeof AnalysisStatus];


export function instanceOfAnalysisStatus(value: any): boolean {
    for (const key in AnalysisStatus) {
        if (Object.prototype.hasOwnProperty.call(AnalysisStatus, key)) {
            if (AnalysisStatus[key as keyof typeof AnalysisStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AnalysisStatusFromJSON(json: any): AnalysisStatus {
    return AnalysisStatusFromJSONTyped(json, false);
}

export function AnalysisStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): AnalysisStatus {
    return json as AnalysisStatus;
}

export function AnalysisStatusToJSON(value?: AnalysisStatus | null): any {
    return value as any;
}

export function AnalysisStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): AnalysisStatus {
    return value as AnalysisStatus;
}

